/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type QueryListSquiggliesQueryVariables = {
    regex?: string | null | undefined;
    includePatientFormTemplates?: boolean | null | undefined;
    includeLumabotFlowTemplates?: boolean | null | undefined;
};
export type QueryListSquiggliesQueryResponse = {
    readonly viewer: {
        readonly salesforceData: {
            readonly provisioning: ReadonlyArray<string | null> | null;
        } | null;
    } | null;
    readonly patientFormTemplateMany?: ReadonlyArray<{
        readonly tag: string | null;
        readonly title: string | null;
    } | null> | null | undefined;
    readonly lumabotFlowTemplateMany?: ReadonlyArray<{
        readonly tag: string | null;
        readonly title: string | null;
    } | null> | null | undefined;
};
export type QueryListSquiggliesQuery = {
    readonly response: QueryListSquiggliesQueryResponse;
    readonly variables: QueryListSquiggliesQueryVariables;
};



/*
query QueryListSquiggliesQuery(
  $regex: String = ""
  $includePatientFormTemplates: Boolean = false
  $includeLumabotFlowTemplates: Boolean = false
) {
  viewer {
    salesforceData {
      provisioning
    }
    id
  }
  patientFormTemplateMany(limit: 500, sort: TITLE_ASC, filter: {AND: [{active: true, _operators: {lumabot: {nin: [true]}}}], OR: [{_operators: {tag: {regex: $regex}}}, {_operators: {title: {regex: $regex}}}]}) @include(if: $includePatientFormTemplates) {
    tag
    title
    id
  }
  lumabotFlowTemplateMany(limit: 500, sort: TITLE_ASC, filter: {active: true, OR: [{_operators: {tag: {regex: $regex}}}, {_operators: {title: {regex: $regex}}}]}) @include(if: $includeLumabotFlowTemplates) {
    tag
    title
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeLumabotFlowTemplates"
},
v1 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includePatientFormTemplates"
},
v2 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "regex"
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "UserSalesforceData",
  "kind": "LinkedField",
  "name": "salesforceData",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "provisioning",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "regex",
    "variableName": "regex"
  }
],
v5 = {
  "items": [
    {
      "fields": [
        {
          "fields": [
            {
              "fields": (v4/*: any*/),
              "kind": "ObjectValue",
              "name": "tag"
            }
          ],
          "kind": "ObjectValue",
          "name": "_operators"
        }
      ],
      "kind": "ObjectValue",
      "name": "OR.0"
    },
    {
      "fields": [
        {
          "fields": [
            {
              "fields": (v4/*: any*/),
              "kind": "ObjectValue",
              "name": "title"
            }
          ],
          "kind": "ObjectValue",
          "name": "_operators"
        }
      ],
      "kind": "ObjectValue",
      "name": "OR.1"
    }
  ],
  "kind": "ListValue",
  "name": "OR"
},
v6 = {
  "kind": "Literal",
  "name": "limit",
  "value": 500
},
v7 = {
  "kind": "Literal",
  "name": "sort",
  "value": "TITLE_ASC"
},
v8 = [
  {
    "fields": [
      {
        "kind": "Literal",
        "name": "AND",
        "value": [
          {
            "_operators": {
              "lumabot": {
                "nin": [
                  true
                ]
              }
            },
            "active": true
          }
        ]
      },
      (v5/*: any*/)
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  (v6/*: any*/),
  (v7/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tag",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v11 = [
  (v9/*: any*/),
  (v10/*: any*/)
],
v12 = [
  {
    "fields": [
      (v5/*: any*/),
      {
        "kind": "Literal",
        "name": "active",
        "value": true
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  (v6/*: any*/),
  (v7/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v14 = [
  (v9/*: any*/),
  (v10/*: any*/),
  (v13/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "QueryListSquiggliesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "condition": "includePatientFormTemplates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v8/*: any*/),
            "concreteType": "PatientFormTemplate",
            "kind": "LinkedField",
            "name": "patientFormTemplateMany",
            "plural": true,
            "selections": (v11/*: any*/),
            "storageKey": null
          }
        ]
      },
      {
        "condition": "includeLumabotFlowTemplates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v12/*: any*/),
            "concreteType": "LumabotFlowTemplate",
            "kind": "LinkedField",
            "name": "lumabotFlowTemplateMany",
            "plural": true,
            "selections": (v11/*: any*/),
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "QueryListSquiggliesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v13/*: any*/)
        ],
        "storageKey": null
      },
      {
        "condition": "includePatientFormTemplates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v8/*: any*/),
            "concreteType": "PatientFormTemplate",
            "kind": "LinkedField",
            "name": "patientFormTemplateMany",
            "plural": true,
            "selections": (v14/*: any*/),
            "storageKey": null
          }
        ]
      },
      {
        "condition": "includeLumabotFlowTemplates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v12/*: any*/),
            "concreteType": "LumabotFlowTemplate",
            "kind": "LinkedField",
            "name": "lumabotFlowTemplateMany",
            "plural": true,
            "selections": (v14/*: any*/),
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "4c783310f68fed64446272e7bb0329e9",
    "id": null,
    "metadata": {},
    "name": "QueryListSquiggliesQuery",
    "operationKind": "query",
    "text": "query QueryListSquiggliesQuery(\n  $regex: String = \"\"\n  $includePatientFormTemplates: Boolean = false\n  $includeLumabotFlowTemplates: Boolean = false\n) {\n  viewer {\n    salesforceData {\n      provisioning\n    }\n    id\n  }\n  patientFormTemplateMany(limit: 500, sort: TITLE_ASC, filter: {AND: [{active: true, _operators: {lumabot: {nin: [true]}}}], OR: [{_operators: {tag: {regex: $regex}}}, {_operators: {title: {regex: $regex}}}]}) @include(if: $includePatientFormTemplates) {\n    tag\n    title\n    id\n  }\n  lumabotFlowTemplateMany(limit: 500, sort: TITLE_ASC, filter: {active: true, OR: [{_operators: {tag: {regex: $regex}}}, {_operators: {title: {regex: $regex}}}]}) @include(if: $includeLumabotFlowTemplates) {\n    tag\n    title\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '36885574d6986bd24b172d2cfa88894f';
export default node;
